<template>
  <div>
    <GenericFilter
      :options="products"
      :value="products.filter(p => (value || []).includes(p.id))"
      :loading="loading"
      :limit="limit"
      :placeholder="$t('views.seller.reports.text_1430')"
      :show-select-all="false"
      :track-by="'id'"
      :label-key="'name'"
      @input="onInput"
      @search-change="debounceSearch"
      style="width: 100%; position: relative; top: -7px;"
    />
  </div>
</template>

<script>
import GenericFilter from '@/components/GenericFilter.vue';
import ProductService from "@/services/resources/ProductService";

const serviceProduct = ProductService.build();

export default {
  components: {
    GenericFilter,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      products: [],
      search: "",
      loading: false,
      limit: 3,
    };
  },
  watch: {
    filter: {
      handler: function () {
        this.$parent.fetchReport();
      },
      deep: true,
    },
  },
  computed: {
    filter() {
      return this.$store.getters.getFilters;
    },
  },
  methods: {
    fetchProducts(search = null) {
      let data = {
        list: true,
        with_participants: true
      };
      if (search) data.search = search;
      this.loading = true;
      serviceProduct
        .search(data)
        .then((response) => {
          this.products = response.map(({ id, name }) => ({ id, name }));
        })
        .catch(() => {
          this.products = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    debounceSearch(query) {
      this.loading = true;
      this.search = query;
      setTimeout(() => {
        this.fetchProducts(this.search);
      }, 500);
    },
    onInput(val) {
      this.$store.commit("setFilters", { products: val.map((item) => item.id) });
      this.$emit("input", val.map((item) => item.id));
    }
  },
  mounted() {
    this.fetchProducts();
    this.$parent.fetchReport();
  },
};
</script>

<style scoped>
::v-deep(.product-filter .multiselect__tags) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-right: 33px !important;
  flex-wrap: wrap;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
}

::v-deep(.product-filter .multiselect__select) {
  top: 0px !important;
}

::v-deep(.product-filter .multiselect__tags-wrap) {
  display: flex !important;
  align-content: center !important;
  justify-content: flex-start !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  flex-direction: row !important;
  gap: 5px !important;
  padding-right:5px !important;
}

::v-deep(.product-filter .multiselect__tag) {
  margin: 0 !important;
}

::v-deep(.product-filter #ajax) {
  margin-top:10px;
  position: relative;
  width: 100%;
}
</style>